// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* index.css or App.css */
body {
  margin: 0;
  padding: 0;
  background-image: url('https://s7d2.scene7.com/is/image/Caterpillar/CM20190621-ac965-b7e2f');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed; /* optional: makes it stay fixed while scrolling */
  min-height: 100vh;
  font-family: 'Roboto', sans-serif; /* optional, matches MUI's default */
}


code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,SAAS;EACT,UAAU;EACV,4FAA4F;EAC5F,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B,EAAE,kDAAkD;EAChF,iBAAiB;EACjB,iCAAiC,EAAE,oCAAoC;AACzE;;;AAGA;EACE;aACW;AACb","sourcesContent":["/* index.css or App.css */\nbody {\n  margin: 0;\n  padding: 0;\n  background-image: url('https://s7d2.scene7.com/is/image/Caterpillar/CM20190621-ac965-b7e2f');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed; /* optional: makes it stay fixed while scrolling */\n  min-height: 100vh;\n  font-family: 'Roboto', sans-serif; /* optional, matches MUI's default */\n}\n\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
